import React from "react";
import Button from "@material-ui/core/Button";
import { Typography, Container } from "@material-ui/core";
import useStyles from "./styles";
import { useHistory } from "react-router-dom";

const ErrorPage = () => {
  const history = useHistory();
  const classes = useStyles();
  return (
    <div className={classes.bodyStyle}>
      <Container maxWidth="md">
        <Typography
          className={classes.typographyStyle}
          variant="h5"
          align="center"
          gutterBottom
        >
          Oops! Something went wrong.
        </Typography>
        <Typography
          className={classes.typographyStyle}
          variant="h6"
          align="center"
          gutterBottom
        ></Typography>
        <Typography
          className={classes.typographyStyle}
          align="center"
          gutterBottom
        >
          <Button
            onClick={() => {
              history.push("/");
            }}
            variant="contained"
            color="primary"
          >
            Try again
          </Button>
        </Typography>
      </Container>
    </div>
  );
};

export default ErrorPage;
